module.exports = __webpack_public_path__ + "img/icon-delete.5b9df19e.svg";